import { useState } from "react";

const DEFAULT_ROWS = [
  { key: "delivery_failed", label: "Webhook delivery failed (all retries exhausted)", email: true, sms: true },
  { key: "feed_unreachable", label: "Feed unreachable for 24h+", email: true, sms: false },
  { key: "plan_limit", label: "Approaching plan limit (90%+)", email: true, sms: false },
  { key: "downtime_soon", label: "Scheduled downtime starting soon", email: false, sms: false },
  { key: "monthly_summary", label: "Monthly usage summary", email: true, sms: false },
];

/**
 * NotificationPreferences
 * Props:
 *   rows — same shape as DEFAULT_ROWS; defaults provided
 *   onSave(rows)
 */
export default function NotificationPreferences({ rows: initialRows = DEFAULT_ROWS, onSave }) {
  const [rows, setRows] = useState(initialRows);

  function toggle(key, channel) {
    setRows((prev) => prev.map((r) => (r.key === key ? { ...r, [channel]: !r[channel] } : r)));
  }

  return (
    <div>
      <p style={{ fontWeight: 500, fontSize: "var(--text-lg)", margin: "0 0 4px" }}>Notification preferences</p>
      <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "0 0 18px" }}>
        Choose how you're alerted about account and delivery events.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 70px 70px", gap: 12, padding: "6px 12px", fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>
        <span>Event</span><span style={{ textAlign: "center" }}>Email</span><span style={{ textAlign: "center" }}>SMS</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {rows.map((r) => (
          <div key={r.key} className="ical-row" style={{ display: "grid", gridTemplateColumns: "1fr 70px 70px", alignItems: "center", gap: 12 }}>
            <p style={{ margin: 0, fontSize: "var(--text-sm)" }}>{r.label}</p>
            <div style={{ textAlign: "center" }}>
              <input type="checkbox" checked={r.email} onChange={() => toggle(r.key, "email")} />
            </div>
            <div style={{ textAlign: "center" }}>
              <input type="checkbox" checked={r.sms} onChange={() => toggle(r.key, "sms")} />
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="ical-btn ical-btn-primary" style={{ marginTop: 16 }} onClick={() => onSave?.(rows)}>
        Save preferences
      </button>
    </div>
  );
}
